import React from "react";
import ProductTemplate from "../../ProductTemplate";
import s560Cover from "../../../assets/s560/S560Cover.png";
import s560a from "../../../assets/s560/s560a.jpg";
import s560b from "../../../assets/s560/s560b.jpg";
import s560c from "../../../assets/s560/s560Cover.jpg";
import s560d from "../../../assets/s560/s560d.jpg";
import s560sec1 from "../../../assets/s560/s560sec1.png";
import s560sec2 from "../../../assets/s560/s560sec2.png";
import s560sec3 from "../../../assets/s560/s560sec3.png";

const S560 = () => {
  const data = {
    title: "ALUMIL S560",
    subtitle: "Lift & slide insulated system SMARTIA S560",
    description:
      "SMARTIA S560 is a robust, thermally insulated, lift & slide and regular sliding system, which provides high thermal performance, modern design and is ideal for constructions with wide spans.",
    specifications: [
      { label: "UW", value: "From 2.3 W/m²K" },
      { label: "AIR PERMEABILITY", value: "Class 4" },
      { label: "WATER TIGHTNESS", value: "Class E1200" },
      { label: "RESISTANCE TO WIND LOAD", value: "C5/B5" },
      { label: "SOUND REDUCTION", value: "42 dB" },
      { label: "BURGLAR RESISTANCE", value: "RC2" },
    ],
    renders: [s560Cover, s560a, s560b, s560c, s560d],
    typologies: [
     
    ],
    sections: [s560sec1, s560sec2, s560sec3],
    relatedFiles: [
      {
        label: "S560 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/smartia/pre-q-smartia-s560-en.pdf?sfvrsn=15af6807_14",
      },
      {
        label: "S560 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/smartia/s560_en.pdf?sfvrsn=d1ced215_61",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default S560;